// auth/authentication.service.ts
import { Injectable, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { UserService } from '../services/user.service';
import { environment } from '../../environments/environment';
import { getAuthConfig, getLogoutUrl } from './auth.config';
import { PlatformLocation } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private readonly oauthService = inject(OAuthService);
  private readonly userService = inject(UserService);
  private readonly platformLocation = inject(PlatformLocation);

  private baseHref = this.platformLocation.getBaseHrefFromDOM();

  async initialize(): Promise<void> {
    this.oauthService.configure(getAuthConfig(environment, this.baseHref));
    this.oauthService.setupAutomaticSilentRefresh();

    await this.oauthService.loadDiscoveryDocumentAndTryLogin();

    if (this.oauthService.hasValidAccessToken()) {
      this.setUsernameFromClaims();
    }

    this.oauthService.events.subscribe((event) => {
      if (event.type === 'token_received') {
        this.setUsernameFromClaims();
      }
    });
  }

  private setUsernameFromClaims(): void {
    const claims = this.oauthService.getIdentityClaims() as { email?: string } | null;
    if (claims?.email) {
      this.userService.updateUsername(claims.email);
    }
  }

  logout(): void {
    this.oauthService.logOut(true);
    window.location.href = getLogoutUrl(environment, this.baseHref);
  }
}
